"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubMenu = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var MenuState_1 = require("./MenuState");
var MenuOpener_1 = require("./menuOpener/MenuOpener");
/**
 * @internal
 */
exports.SubMenu = function (props) { return (react_1.default.createElement(MenuState_1.MenuState, { opened: props.opened, defaultOpened: props.defaultOpened, onOpenedChange: props.onOpenedChange }, function (_a) {
    var opened = _a.opened, onOpenedChange = _a.onOpenedChange;
    return (react_1.default.createElement(MenuOpener_1.MenuOpener, { opened: opened, onOpenedChange: onOpenedChange, topLevelMenu: false, openAction: props.openAction, toggler: props.toggler, alignment: props.alignment, spacing: props.spacing, offset: props.offset }, props.children));
})); };
//# sourceMappingURL=SubMenu.js.map